import {Component, computed, input} from '@angular/core'
import {MatIcon} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'
import {BlancoEventCode, eventCodes, IBlancoResultCode, LIMIT_SUPERFAST} from '@sparbanken-syd/blanco-backend'

export const EVENT_CODE_TITLES: Record<BlancoEventCode, string> = {
  [eventCodes.submitted]: 'Inskickad',
  [eventCodes.signed]: 'Signerad',
  [eventCodes.manual]: 'Handläggare',
  [eventCodes.duplicate]: 'Dublett',
  [eventCodes.uc]: 'UC',
  [eventCodes.kalp]: 'Kalp',
  [eventCodes.incomeDiff]: 'Inkomst diff UC/kund',
  [eventCodes.occupation]: 'Sysselsättning',
  [eventCodes.incomeDiffCo]: 'Inkomst diff (medsökande)',
  [eventCodes.interestCalc]: 'Erbjuden ränta',
  [eventCodes.closed]: 'Stängd',
  [eventCodes.declined]: 'Kund avböjde',
  [eventCodes.accepted]: 'Kund accepterat',
  [eventCodes.propertyLoanDiff]: 'Bolån diff UC/kund',
  [eventCodes.incomeReview]: 'Inkomstkontroll',
  [eventCodes.createdMp]: 'Lån skapat i MP',
  [eventCodes.contact]: 'Kund kontaktad',
  [eventCodes.contactFail]: 'Kontaktförsök misslyckat',
  [eventCodes.limitSuperFastAmount]: `Lånebelopp > ${LIMIT_SUPERFAST.toLocaleString('sv-SE')} kr`,
  [eventCodes.blancoLoanDiff]: 'Privatlån diff UC/kund'
}

/**
 * Connect event codes to specific icons.
 */
const ERROR_ICONS: Record<string, string> = {
  [eventCodes.uc]: 'gavel',
  [eventCodes.kalp]: 'clear',
  [eventCodes.declined]: 'warning',
  [eventCodes.incomeDiff]: 'compare_arrows',
  [eventCodes.incomeDiffCo]: 'compare_arrows',
  [eventCodes.manual]: 'assignment_late',
  [eventCodes.duplicate]: 'group_add',
  [eventCodes.propertyLoanDiff]: 'compare_arrows',
  [eventCodes.incomeReview]: 'verified_user',
  [eventCodes.blancoLoanDiff]: 'compare_arrows',
}

@Component({
  selector: 'spb-indicator',
  templateUrl: './indicator.component.html',
  imports: [MatIcon, MatTooltip]
})
export class IndicatorComponent {
  public codeList = input.required<IBlancoResultCode[]>()

  public readonly indicator = computed(() => {
    const codes = this.codeList()

    // Default values
    let color = 'green'
    let icon = 'done_outline'

    // If there is a code that is accepted and approved, do nothing and return immediately
    if (codes.some((code) => code.name === eventCodes.accepted && code.pass)) {
      return {color, icon}
    }

    // If 'CODE_MANUAL' exists, select it; otherwise, select the first code where 'pass' is false
    const manual = codes.find((c) => c.name === eventCodes.manual)
    const error = manual || codes.find((c) => !c.pass)

    let title = ''

    if (error) {
      color = 'red'
      title = EVENT_CODE_TITLES[error.name] ?? ''
      // Try to find a matching icon for the error code
      const matchedIcon = ERROR_ICONS[error.name]

      // Only update icon if a specific mapping exists, otherwise keep default
      if (matchedIcon) {
        icon = matchedIcon
      }
    }

    return {color, icon, title}
  })
}